import { render, staticRenderFns } from "./RoundTab.vue?vue&type=template&id=4f3cc244&scoped=true&"
import script from "./RoundTab.vue?vue&type=script&lang=js&"
export * from "./RoundTab.vue?vue&type=script&lang=js&"
import style0 from "./RoundTab.vue?vue&type=style&index=0&id=4f3cc244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3cc244",
  null
  
)

export default component.exports